import { v4 as uuidv4 } from "uuid";
function chillHop() {
  return [
    {
      name: "Lose Her Way",
      cover:
        "https://chillhop.com/wp-content/uploads/2022/04/8cc8bdc59b30dd1f9d401cb485b8537d909e1f50-1024x1024.jpg",
      artist: "C Y G N",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=31589",
      color: ["#D4D4CC", "#228751"],
      id: uuidv4(),
      active: true,
    },
    {
      name: "Night Fishing",
      cover:
        "https://chillhop.com/wp-content/uploads/2022/04/8cc8bdc59b30dd1f9d401cb485b8537d909e1f50-1024x1024.jpg",
      artist: "C Y G N",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=31591",
      color: ["#D4D4CC", "#228751"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Vision Nocturne",
      cover:
        "https://chillhop.com/wp-content/uploads/2022/04/8cc8bdc59b30dd1f9d401cb485b8537d909e1f50-1024x1024.jpg",
      artist: "C Y G N",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=31608",
      color: ["#D4D4CC", "#228751"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Quiet Night Rain",
      cover:
        "https://chillhop.com/wp-content/uploads/2022/04/8cc8bdc59b30dd1f9d401cb485b8537d909e1f50-1024x1024.jpg",
      artist: "C Y G N",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=31599",
      color: ["#D4D4CC", "#228751"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "Caramel",
      cover:
        "https://chillhop.com/wp-content/uploads/2022/03/d47e340cee0956dd4457620a97e4a9df7f849ddb-1024x1024.jpg",
      artist: "Leavv",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=34162",
      color: ["#D03652", "#DDD1BA"],
      id: uuidv4(),
      active: false,
    },
    {
      name: "la zona",
      cover:
        "https://chillhop.com/wp-content/uploads/2021/11/3ff29a35be582c8dc0222273cb9c401ea6b209dc-1024x1024.jpg",
      artist: "Maydee",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=27455",
      color: ["#84A3C0", "#827562"],
      id: uuidv4(),
      active: false,
    },
  ];
}

export default chillHop;
